// extracted by mini-css-extract-plugin
export default {"title":"UI_ITOModuleTitle_title__5RzbI"};